import clsx from 'clsx';
import React from 'react';
import { Icon, Tooltip } from 'ui';

type IconProps = React.ComponentProps<typeof Icon>;

type StatusIconProps = Readonly<{
  className?: string;
  color?: IconProps['color'];
  iconName: IconProps['name'];
  label: string;
  shouldShowTooltip?: boolean;
  size?: IconProps['size'];
}>;

/** El texto sr-only va fuera del Tooltip: MUI pone title y aria-describedby en el disparador y el lector lo leería dos veces. */
function StatusIcon({ className, color, iconName, label, shouldShowTooltip = false, size }: StatusIconProps): JSX.Element {
  const icon = (
    <span aria-hidden="true" className={clsx('status-icon', className)}>
      <Icon color={color} name={iconName} size={size} />
    </span>
  );

  return (
    <>
      {shouldShowTooltip ? (
        <Tooltip hasArrow placement="top" title={label}>
          {icon}
        </Tooltip>
      ) : (
        icon
      )}
      <span className="sr-only">{label}</span>
    </>
  );
}

export default StatusIcon;
